<template>
    <div>
        <div
            v-if="type == 'bulkCustomersOnboarding'"
            class="download-current-file"
            style="margin-bottom: 1rem"
        >
            <!-- @click.prevent="reset() -->
            <button
                class="btn btn-link btn-reset"
                :disabled="loading || disabled"
                @click.prevent="reset()"
            >
                <i class="icon-loop"></i>

                <span class="btn-text">Reset</span>
            </button>
            <b-form-checkbox
                v-model="checked"
                name="check-button"
                switch
                @change="toggleNoEngineRun()"
            >
                <b>No Engine Run</b>
            </b-form-checkbox>
        </div>
        <b-form-group
            id="input-group-5"
            :label="labelVal"
            label-for="label"
            :class="uploadFileCss ? 'upload-files' : ''"
        >
            <b-form-file
                id="profile-picture"
                ref="file"
                v-bind="$attrs"
                :placeholder="placeholderVal"
                drop-placeholder="Drop file here..."
                :accept="acceptFile"
                class="zindex"
                @change="uploadImage"
            ></b-form-file>
            <slot></slot>
        </b-form-group>
        <b-modal
            id="error-popup"
            ref="errorPopup"
            title="Error in file content"
            :hide-header-close="loading"
            size="md"
            hide-footer
            modal-class="hide-footer"
            no-close-on-backdrop
            no-close-on-esc
            @hidden="onHidden"
        >
            <div class="col-md-12 row-min-space">
                <div class="scrollable more-fields-popup">
                    <h5 style="padding: 20px">
                        Kindly fix the following errors in your file:
                    </h5>
                    <ul>
                        <li v-for="error in errors" :key="error">
                            {{ error }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-12 action-buttons">
                <b-button
                    type="button"
                    variant="primary"
                    :class="loading ? 'disabled' : ''"
                    @click="closePopup"
                >
                    <span class="btn-text">Close</span>
                    <span class="loader"></span>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import path from 'path'
const apiUrl = process.env.VUE_APP_API_URL
export default {
    components: {},
    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
    props: {
        type: {
            type: String,
            required: true,
        },
        labelVal: {
            type: String,
        },
        placeholderVal: {
            type: String,
            default: 'Choose file to upload',
        },
        acceptFile: {
            type: String,

            default:
                'image/jpeg, image/png, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
        uploadFileCss: {
            type: Boolean,
            default: null,
        },
        importFileRun: {
            type: Boolean,
            default: false,
        },
        importCustomFile: {
            type: Boolean,
            default: false,
        },
        size: {
            type: Number,
            default: 20,
        },
        checkedVal: {
            type: Boolean,
            default: false,
        },
        columnConfig: {
            type: Array,
            default: null,
        },
        importDataEntryFile: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
        },
    }, // End of Component > props

    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {
            uploadPercentage: 0,
            errors: [],
            noEngineRun: false,
        }
    }, // End of Component > data

    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {
        ...mapGetters([
            'user',
            'dataSegmentId',
            'formBuilderList',
            'loading',
            'getConfigurationOcrData',
        ]),
    }, // End of Component > computed
    watch: {
        imagePreviewURL(value) {
            this.previewImage = value
        },
    }, // End of Component > watch

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    mounted() {
        this.$refs.file.reset()
    }, // End of Component > mounted

    /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
    methods: {
        toggleNoEngineRun() {
            this.noEngineRun = !this.noEngineRun
            alert(
                'This will only upload customers and not run engine on auto ' +
                    JSON.stringify(this.noEngineRun)
            )
        },
        //Upload image
        async uploadImage(e) {
            let self = this
            this.$store.commit('setLoading', true)

            const file = e.target.files[0]
            try {
                let formData = new FormData()
                if (file) {
                    const originalName = file.name
                    /*
                        Add the form data we need to submit
                    */

                    formData.append('type', this.type)
                    formData.append('file', file)

                    if (this.formatBytes(file.size)) {
                        this.$toasted.show(
                            `File size must be less than ${this.size} MB`,
                            {
                                duration: 3000,
                                type: ['error'],
                            }
                        )
                        return false
                    }
                    let ext = path.extname(originalName)
                    console.log('ext for file to be uploaded', ext)
                    if (
                        this.type == 'bulkCustomersOnboarding' &&
                        !this.acceptFile.includes(ext)
                    ) {
                        // checking if file format is supported for bulk-customers-uploading
                        this.$toasted.show(
                            `Accepted file formats are ${this.acceptFile} only`,
                            {
                                duration: 3000,
                                type: ['error'],
                            }
                        )
                        this.$emit('show-progress', 0)
                        return false
                    }

                    let response = await axios.post(
                        apiUrl + 'files/',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                Authorization: `Bearer ${localStorage.getItem(
                                    'vueauth_token'
                                )}`,
                            },

                            onUploadProgress: function (progressEvent) {
                                this.uploadPercentage = parseInt(
                                    Math.round(
                                        (progressEvent.loaded /
                                            progressEvent.total) *
                                            100
                                    )
                                )
                                if (
                                    this.uploadPercentage < 98 &&
                                    this.importFileRun
                                ) {
                                    self.$emit(
                                        'show-progress',
                                        this.uploadPercentage
                                    )
                                }
                            },
                        }
                    )
                    response.data.data.originalName = originalName
                    this.$emit('set-value', response.data.data)

                    if (
                        this.type === 'bulkCustomersOnboarding' &&
                        this.type !== 'deltaListUploading'
                    ) {
                        // to be used for bulk customers uploading specifically for the NTB by silk
                        console.log('bulk-customers')
                        let obj = {
                            fileName: response.data.data.fileName,
                            dataSegmentId: this.dataSegmentId,
                            filePath: response.data.data.filePath,
                        }
                        console.log(obj)
                        if (!this.noEngineRun) {
                            await axios
                                .post(apiUrl + 'customers/etl-transform', obj, {
                                    //etl-transform-jublee
                                    headers: {
                                        Authorization: `Bearer ${localStorage.getItem(
                                            'vueauth_token'
                                        )}`,
                                    },
                                })
                                .then((data) => {
                                    console.log(data)
                                    if (data.data.success) {
                                        this.$toasted.show(data.data.message, {
                                            duration: 5000,
                                            type: 'success',
                                        })
                                    } else {
                                        this.$toasted.show(data.data.message, {
                                            duration: 5000,
                                            type: 'error',
                                        })
                                    }
                                })
                        } else {
                            await axios
                                .post(
                                    apiUrl + 'customers/etl-transform-jublee',
                                    obj,
                                    {
                                        //etl-transform-jublee
                                        headers: {
                                            Authorization: `Bearer ${localStorage.getItem(
                                                'vueauth_token'
                                            )}`,
                                        },
                                    }
                                )
                                .then((data) => {
                                    console.log(data)
                                    if (data.data.success) {
                                        this.$toasted.show(data.data.message, {
                                            duration: 5000,
                                            type: 'success',
                                        })
                                    } else {
                                        this.$toasted.show(data.data.message, {
                                            duration: 5000,
                                            type: 'error',
                                        })
                                    }
                                })
                        }
                    }

                    if (
                        this.importFileRun &&
                        this.type !== 'bulkCustomersOnboarding' &&
                        this.type !== 'deltaListUploading'
                    ) {
                        let filename = response.data.data.fileName
                        let obj = {}
                        obj.fileName = filename
                        obj.dataSegmentId = this.dataSegmentId

                        await axios.post(
                            apiUrl + 'screening-data/import/',
                            obj,
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${localStorage.getItem(
                                        'vueauth_token'
                                    )}`,
                                },
                            }
                        )
                        this.$emit('show-progress', 100)
                    }
                    // if (this.importCustomFile) {
                    //     await this.handleCustomFile(response)
                    // } // commented by ammar. not sure what these are used for. therefore commented. if to be used somewhere please specify.

                    // if (this.importDataEntryFile) {
                    //     this.handleDataEntry(response)
                    // } // commented by ammar. not sure what these are used for. therefore commented. if to be used somewhere please specify.
                    if (
                        this.type !== 'bulkCustomersOnboarding' &&
                        this.type == 'deltaListUploading'
                    ) {
                        // to be used for delta file uploading
                        let filename = response.data.data.fileName
                        let obj = {}
                        obj.fileName = filename
                        obj.dataSegmentId = this.dataSegmentId
                        await axios.post(
                            apiUrl + 'screening-data/importDelta/',
                            obj,
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${localStorage.getItem(
                                        'vueauth_token'
                                    )}`,
                                },
                            }
                        )
                    }
                    this.$emit('show-progress', 100)
                    this.$emit('uploaded', true)
                }
            } catch (error) {
                console.log('baseFileUpload error', error)
            }
            this.$store.commit('setLoading', false)
        }, // End of upload image function

        async handleCustomFile(response) {
            // console.log("checkd value: ",this.checkedVal)
            let filename = response.data.data.fileName
            let obj = {}
            obj.fileName = filename
            obj.dataSegmentId = this.dataSegmentId
            obj.checkedVal = this.checkedVal
            obj.columnConfig = this.columnConfig
            obj.userEmail = this.user.email
            let result = await axios.post(
                apiUrl + 'screening-data/merge/',
                obj,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem(
                            'vueauth_token'
                        )}`,
                    },
                }
            )

            if (result.status == 201) {
                if (result.data.errors) {
                    this.errors = [...result.data.errors]
                    this.$refs.errorPopup.show()
                } else {
                    this.$toasted.show(result.data.message, {
                        duration: 4000,
                        type: ['error'],
                    })
                }

                this.$refs.file.reset()
            } else {
                // this.columnConfig = result.data.columns
                this.$toasted.show(result.data.message, {
                    duration: 3000,
                    type: ['success'],
                })
                this.$emit('show-progress', 100)
                this.$refs.file.reset()
                // this.$emit('set-file', result.data.data)
            }
        },

        async handleDataEntry(response) {
            const ocrData = this.getConfigurationOcrData
            let filename = response.data.data.fileName
            let obj = {}
            obj.fileName = filename
            obj.dataSegmentId = this.dataSegmentId
            obj.restrictDuplicateRecords = ocrData.restrictDuplicateRecords
            let result = await axios.post(
                apiUrl + 'screening-data/merge-data-entry/',
                obj,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem(
                            'vueauth_token'
                        )}`,
                    },
                }
            )
            this.$emit('show-progress', 100)
            // this.$emit('set-file', result.data.data)
        },
        formatBytes(bytes) {
            return (
                (bytes / 1048576).toFixed(3) >
                (typeof this.size != 'undefined' ? this.size : 20)
            )
        }, // End of formatBytes function

        closePopup() {
            this.$refs.errorPopup.hide()
        },
        reset() {
            this.$refs.file.reset()
            this.$emit('show-progress', 0)
        },
    },
} // End of export default
</script>
